<template>
  <div class="platform-regulations-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header title="Regulamento da Plataforma"></app-page-header>

    <app-card>
      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-12">
            <app-input
              v-model="regulation.title"
              :errors="errors.title"
              label="Título"
              maxlength="256"
              required
            ></app-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-field label="Regulamento" required>
              <editor
                v-model="regulation.text"
                :errors="errors.text"
                api-key="8tcgv8vqclsf5uhooax65dbbp0d4lbw0yvulc2wjwha7a1dp"
                :init="{
                  height: 300,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
                }"
              />
            </b-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button
              :disabled="$v.$invalid || isSaving"
              type="submit"
              v-app-button
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
    </app-card>
  </div>
</template>

<script>
import PlatformRegulationsService from '@/services/platform-regulation.service';
import Editor from '@tinymce/tinymce-vue';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'platform-regulations-page',
  components: {
    Editor,
  },
  data: () => {
    return {
      errors: {},
      regulation: {
        title: null,
        text: null,
      },
      isSaving: false,
    };
  },
  validations: {
    regulation: {
      title: { required },
      text: { required },
    },
  },
  methods: {
    onSubmit() {
      this.regulation.id && this.update(this.regulation);
      !this.regulation.id && this.save(this.regulation);
    },
    save(regulation) {
      this.isSaving = true;
      PlatformRegulationsService.save(regulation)
        .then(() => {
          this.toastify('Regulamento da Plataforma cadastrado com sucesso!');
          this.$router.push({ name: 'platform-regulations.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Regulamento da Plataforma.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(regulation) {
      this.isSaving = true;
      PlatformRegulationsService.update(regulation.id, regulation)
        .then(() => {
          this.toastify('Regulamento da Plataforma atualizado com sucesso!');
          // this.$router.push({ name: "platform-regulations.index" });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Regulamento da Plataforma.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    load() {
      PlatformRegulationsService.get().then(
        ({ data: regulation }) => (this.regulation = regulation)
      );
    },
  },
  mounted() {
    this.load();
  },
};
</script>
